import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { SharedDealService } from "@js/services/Deal/SharedDealService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import angular from "angular";
import {
  AccountClient,
  AddressLookupDTO,
  ApplicationUser,
  ApplicationUserCrudClient,
  AppraisalModuleEnum,
  BrickflowEventLogClient,
  CaseAccessLevelEnum,
  CaseChangedMessageDTO,
  CaseLenderStateEnum,
  CaseStatusEnum,
  Client,
  CommercialDeal,
  CommercialDealClient,
  CommercialDealCrudClient,
  DealClient,
  DealClientClient,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  EventLogEnum,
  ExternalLinks,
  ExternalLinksClient,
  FixedRateTermEnum,
  InterestRateTypeEnum,
  Lender,
  LenderClient,
  LenderInfo,
  LenderProductTypeEnum,
  ModuleEnum,
  Organisation,
  OrganisationClient,
  OwnershipRoleEnum,
  OwnNewDevelopmentEnum,
  OwnOrPurchaseEnum,
  PostalAddress,
  ProductFamilyEnum,
  ProductTypeEnum,
  PromoteSearchToCaseResponse,
  SaveCommercialSearchRequest,
  ShareModuleRequest,
  StreetAddressClient,
  SubmitToLendersRequest,
  SwaggerException,
  TenureEnum,
  TitleEnum,
  UserSimpleDTO,
  YesNoMaybe,
  CommercialDealUpdate,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";
import CommercialDealHelper from "@js/helpers/CommercialDealHelper";
import DealHelper from "@js/helpers/DealHelper";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { AddressHistoryDTO } from "@js/DTO/AddressHistoryDTO.cs";
import { BaseCaseController } from "@js/controllers/BaseCaseController";
import { IndexService } from "@js/services/IndexService";
import { ErrorCodes } from "@js/errorCode";
import { ErrorMessage } from "@react/components/ErrorMessage";

interface LeaseItemDetails {
  timeLeftOnLeaseYears?: number;
  timeLeftOnLeaseMonths?: number;
  grossMonthlyRentalIncome: "";
}

export class CommercialCaseController extends BaseCaseController<CommercialDeal> {
  isCaseDashboard: boolean = true;

  tempDealDto: CommercialDeal;
  orgName: string;
  orgId: number;
  org: Organisation;
  fileNamePrefix: string = "Brickflow";
  mortgageTerm: number = 0;

  selectedNavMenu: number = 0;

  ownershipForm: ng.IFormController;
  companyDetailsForm: ng.IFormController;
  propertyDetailsForm: ng.IFormController;
  loanDetailsForm: ng.IFormController;
  personalDetailsForm: ng.IFormController;
  contactForm: ng.IFormController;
  occupationForm: ng.IFormController;
  creditForm: ng.IFormController;
  lenderDetailsForm: ng.IFormController;

  showAddressHistoryModal: boolean = false;

  tabs = {
    tabOpen: false,
    ownership: false,
    companyDetails: false,
    personalDetails: false,
    contactDetails: false,
    occupation: false,
    credit: false,
  };

  ownershipType: string = "";

  leaseItems: LeaseItemDetails[] = [];

  currentApplicant: DealClient;
  tempApplicant: DealClient;
  applicantList: DealClient[] = [];

  searchterm: string;
  previousAddressSearchTerm: string;
  postCodeOptions: AddressLookupDTO[] = [];
  previousAddressPostCodeOptions: AddressLookupDTO[] = [];
  address: PostalAddress;
  searchingForAddress: boolean = false;
  searchingForPreviousAddress: boolean = false;
  searchresults: string = "";
  previousAddressSearchResults: string[];
  addressHistoryItem: AddressHistoryDTO;
  applicantAddressHistory: AddressHistoryDTO[] = [];

  tenureTypes = [];
  //maritalStatusOptions = [];
  ownOrPurchaseOptions = [];
  ownNewDevelopmentOptions = [];
  yesNoOptions = [];
  planningOptions = [];
  //titleOptions = [];
  ownershipRoleOptions = [];
  //countryList = [];
  //nationalityList = [];
  //countryOfBirthList = [];
  //countryOfResidenceList = [];
  //loanCompletionTypeOptions = [];
  currentUseofBuildingOptions = [];
  loanRepaymentTypeOptions = [];
  productTypeOptions = [];
  fixedrateTermOptions = [];
  locationOptions = [];
  borrowingEntityTypeOptions = [];
  timeLeftOnLeaseOptions = [];
  //modal
  message: string = "";
  modal: boolean = false;
  showErrorMessage: boolean = false;

  uploadingFiles: FileUploadProgressDTO[];
  fileUpload: DealFileAttachment[];
  total: number = 0;
  renamingFile: DealFileAttachment;

  // Controls showing Ts & Cs when a borrower/broker submits to lenders
  showTsAndCs: boolean = false;
  showApplyTsAndCs: boolean = false;
  showTsAndCsForm: boolean = false;
  messagebool: boolean = false;
  invalidEmail: boolean = false;

  isSubmitted: boolean = false;

  isSubmittedToLenders: boolean = false;

  //Boolean to enable a re-submit button
  hasShortlistedDealLenders: boolean = false;

  selectedLendersName: string = "";
  shortlistedLendersName: string = "";
  lendersDetailsForSubmittoLenders: LenderInfo[];
  shortListedLendersId: number[];

  //Sharing case
  caseMembersWithAccess: Client[];
  showShare: boolean = false;
  selectedClientToShareWith: Client;
  showModuleShareConfirmation: boolean;

  //show profile view
  showAppraisalPermission: boolean = false;

  //profile
  newApplicant: DealClient;

  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  maxDateForDateField: Date = new Date("Jan 01 3000");
  showAddorEdit: boolean = false;
  disableQuickEditSave: boolean = false;
  applicantForm: ng.IFormController;
  isAddShareholder: boolean = false;
  showDelete: boolean = false;
  confirmDeleteApplicant: DealClient;

  showExport: boolean = false;
  updatingName: boolean = false;
  orginalDealName: string;

  showAddHistoryConfirmDelete: boolean = false;
  addressHistoryIdToDelete: number;

  isLoggedInUser: boolean = false;

  showDeal: boolean = true;
  // classUses: {} = {};

  missingAddressGaps: string[];

  ownOrPurchase: boolean;
  isFamilyInResidence: boolean;

  dateProperties = ["expiryDate"];

  profileDateProperties = [
    "dateOfBirth",
    "currentAddressFrom",
    "ukResidenceIssueDate",
    "currentEmploymentStartDate",
    "addressStartDate",
  ];

  clientDateProperties = ["dateOfBirth"];

  maxPurchaseDate: Date = new Date();
  minPurchaseDate: Date = new Date("Jan 01 1900");
  dealProductTypeDisplayText: string;
  totalGrossMonthlyRentalIncome: number = 0;
  isGrossMonthlyRentalIncomeMatch: boolean = true;

  //SubmitToLender modal
  brokerCommission: number;
  brokerPreferredContact: string;
  isBrokerPhoneNumberUpdated: boolean = false;
  dealBrokerUser: ApplicationUser;
  offPanelLenderNames: string;

  totalUnreadDealLenderMessages: number = null;

  //Lender Portal Links
  dealLenders: DealLender[];
  dealLendersWithPortalLinkEnabled: DealLender[];
  lendersWithPortalLinkEnabled: Lender[];
  showLenderPortalLinks: boolean = false;
  portalLinks: {} = {};
  borrowerDetails: UserSimpleDTO;
  applicationForm: ng.IFormController;
  portalLinkDetailsAdded: {} = {};

  hasFirstLoadOccurred: boolean = false;
  referredPackagerText: string;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "$cookies",
    "AccountClient",
    "StreetAddressClient",
    "CommercialDealClient",
    "AuthService",
    "SelectListService",
    "RoleService",
    "LenderClient",
    "CaseService",
    "DealLenderClient",
    "DealFileAttachmentClient",
    "$window",
    "ExternalLinksClient",
    "DealClientClient",
    "OrganisationClient",
    "$scope",
    "$sce",
    "DealClient",
    "SharedDealService",
    "DealFileAttachmentHelper",
    "BrickflowEventLogClient",
    "ApplicationUserCrudClient",
    "CommercialDealCrudClient",
    "IndexService",
    "$timeout",
  ];

  constructor(
    $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    accountClient: AccountClient,
    streetAddressClient: StreetAddressClient,
    private commercialDealClient: CommercialDealClient,
    private authService: AuthService,
    selectListService: SelectListService,
    roleService: RoleService,
    private lenderClient: LenderClient,
    private caseService: CaseService,
    dealLenderClient: DealLenderClient,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    $window: ng.IWindowService,
    private externalLinksClient: ExternalLinksClient,
    private dealClientClient: DealClientClient,
    private organisationClient: OrganisationClient,
    $scope: ng.IScope,
    private $sce: ng.ISCEService,
    dealClient: DealClient,
    sharedDealService: SharedDealService,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private eventLogClient: BrickflowEventLogClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    private commercialDealCrudClient: CommercialDealCrudClient,
    indexService: IndexService,
    $timeout: ng.ITimeoutService,
  ) {
    super(
      sharedDealService,
      indexService,
      accountClient,
      dealClient,
      selectListService,
      $location,
      $rootScope,
      roleService,
      applicationUserCrudClient,
      dealLenderClient,
      $timeout,
      streetAddressClient,
      $window,
      $scope,
    );
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }

    this.roleService.GetUserRoles().then((result) => {
      if (result.filter((x) => x.toLowerCase() == "client").length > 0) {
        this.isClient = true;
      } else {
        this.isClient = false;
      }
    });

    if (this.$routeParams.dealId) {
      this.dataLoading = true;

      this.dealId = this.$routeParams.dealId;
      if (this.$routeParams.Promote && this.$routeParams.Promote != "null" && !this.dealDto) {
        var promote = this.$routeParams.Promote as boolean;
        this.isReadOnlyDeal = false;
        this.hasFirstLoadOccurred = true;
        if (promote) {
          this.promoteSearchToCase();
        }
      } else {
        this.dealClient
          .fetchByDealId({
            dealId: this.$routeParams.dealId,
            productFamily: ProductFamilyEnum.Commercial,
            isCaseDashboardCall: true,
          })
          .then((response) => {
            // The case was a pre-existing case when the broker org became a member of Connect and therefore was archived or The lender is trying to access a case where they are not shortlisted
            if (
              (response.commercialDeal && response.commercialDeal.isPreConnectArchived) ||
              response.lenderAccessProhibited
            ) {
              this.$location.path("/dashboard");
            }

            //Below properties are very imp for view roles directive
            this.isReadOnlyDeal = response.isReadOnlyDealForBroker;
            this.referredPackagerText = response.referredPackagerText;

            if (response.hideCommercialDeal) {
              this.message = "You cannot access appraisal now, please contact your admin for more details.";
              this.showDeal = false;
            } else {
              this.dealDto = response.commercialDeal;
              this.shortlistedLendersName = response.shortlistedLendersName;
              this.selectedLendersName = response.selectedLendersName;
              this.shortListedLendersId = response.shortlistedLendersId;
              this.totalUnreadDealLenderMessages = response.totalUnreadDealLenderMessages;

              if (this.dealDto) {
                this.orgId = this.dealDto.brokerOrganisationId;

                this.postRetrieveProcessing();

                var newShortlist = this.$routeParams.NewShortlist as boolean;
                if (newShortlist) this.getLenderPortalLinks();
              } else {
                // If no case is returned, this could be that the logged in user has been removed from the case
                // - only do this if there is a logged in user, otherwise let the routing sort out where the redirect should go
                if ((this.$rootScope as any).selectedUser) {
                  this.$location.path("/dashboard");
                }
              }
            }
          })
          .catch((error: SwaggerException) => {
            if (error.status == ErrorCodes.NotFound) {
              this.message =
                error.response != null && error.response.length > 0
                  ? JSON.parse(error.response)
                  : "Appraisal not found.";
              this.showDeal = false;
            }
          })
          .finally(() => {
            this.hasFirstLoadOccurred = true;
            this.dataLoading = false;
          });
      }
    }

    // this.countryOfBirthList = this.countryOfResidenceList = this.selectListService.GetCountries();
    //this.nationalityList = this.selectListService.GetNationalities();
    this.ownOrPurchaseOptions = this.selectListService.GetOwnOrPurchase();
    //  this.maritalStatusOptions = this.selectListService.GetMaritalStatusOptions();
    this.ownNewDevelopmentOptions = this.selectListService.GetCommercialOwnNewDevelopmentOptions();
    this.yesNoOptions = this.selectListService.GetYesNoForBridging();
    // this.titleOptions = this.selectListService.GetTitleOptions();
    //this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
    this.loanRepaymentTypeOptions = this.selectListService.GetLoanRepaymentTypeOptions();
    this.productTypeOptions = this.selectListService.GetInterestRateType();
    this.fixedrateTermOptions = this.selectListService.GetFixedRateTermOptions();
    this.locationOptions = this.selectListService.GetLocations();
    this.timeLeftOnLeaseOptions = this.selectListService.GetTimeLeftOnLeaseOptions();

    this.getAppName();
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) {
      if (this.isReadOnlyDeal) {
        return `['Admin', 'Client']`;
      } else {
        return `['Admin', 'Client', 'Broker', 'Introducer']`;
      }
    }
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  editDealName() {
    var name = this.dealDto.name;
    this.orginalDealName = name;
    this.updatingName = true;
  }

  cancelEditDealName() {
    this.updatingName = false;
    this.dealDto.name = this.orginalDealName;
  }

  postRetrieveProcessing() {
    if (this.dealDto.projectDescription) {
      this.caseOverview = this.dealDto.projectDescription;
    }

    this.populateAddressField();

    if (this.$routeParams.selectedNavMenu) {
      this.selectedNavMenu = this.$routeParams.selectedNavMenu;
    }

    this.dealLenderClient.fetchByDealId(this.$routeParams.dealId).then((dls: DealLender[]) => {
      this.hasShortlistedDealLenders = dls.some((dl) => dl.status == CaseLenderStateEnum.Shortlisted);
    });

    //These are used for directive.
    (this.$rootScope as any).statusRequirementId = this.dealDto.id;
    this.caseService.updateCaseState(this.dealDto.id, this.dealDto.status);
    this.getCurrentUserAndRoles();
    this.fileUpload = this.dealDto.attachments;
    this.applicantList = this.dealDto.dealClients;

    this.dealProductTypeDisplayText = ProductHelper.getProductTypeDisplayText(this.dealDto.productType);
    this.tenureTypes = this.selectListService.GetTenureTypes(this.dealDto.productType);
    this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.borrowingEntityTypeOptions = this.selectListService.GetBorrowingEntityTypeOptions(this.dealDto.productType);
    this.ownershipRoleOptions = this.selectListService.GetOwnershipRoleOptions(this.dealDto.productType);

    this.offPanelLenderNames = this.dealDto.offPanelLenderNames;

    if (this.dealDto.brokerOrganisationId) {
      this.getOrganisationbyDealId();
    }
  }

  keyPressEvent(event) {
    if (event.key === "Enter") {
      this.updatingName = false;
      this.submitForm(this.dealForm);
    }
    if (event.key === "Escape") {
      this.updatingName = false;
    }
  }

  submitForm(form: ng.IFormController) {
    this.dataLoading = true;

    var request: SaveCommercialSearchRequest = {
      deal: this.dealDto,
      shareDealDto: null,
      orgCode: "",
      enterpriseClientDto: null,
    } as SaveCommercialSearchRequest;

    if (this.leaseItems != null && this.leaseItems.length > 0) {
      this.dealDto.leaseDetails = JSON.stringify(this.leaseItems);
    } else {
      this.dealDto.leaseDetails = "";
    }

    this.commercialDealClient
      .saveCommercialSearchReturnsId(request)
      .then((response) => {
        if (response != null) {
          form.$setPristine();
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  renameCase() {
    this.commercialDealCrudClient.patch({ id: this.dealDto.id, name: this.dealDto.name }).then((response) => {
      this.dataLoading = false;
      this.updatingName = false;
    });
  }

  onTradingStartDateChange() {
    this.dealDto.tradingStartDate = this.modifyDateForBackend(this.dealDto.tradingStartDate);
  }

  closeModalAndGoToDasboard() {
    this.showTsAndCs = false;
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  closeModalAndGoToDealForum() {
    this.showTsAndCs = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  closeModal(test: number) {
    this.messagebool = false;
  }

  getAddressList(searchTerm: string, postalAddress: PostalAddress) {
    let foundMatch = false;

    if (this.postCodeOptions && this.postCodeOptions.length > 0) {
      let addressLookup = this.postCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          for (let prop in address) {
            if (address.hasOwnProperty(prop)) {
              postalAddress[prop] = address[prop];
            }
          }
          this.searchterm = "";
          this.searchresults = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        postalAddress.addressLine1 = addressLookup.addressLine2.replace(
          addressLookup.addressLine2.substring(addressLookup.addressLine2.indexOf("-") - 1),
          "",
        );
        postalAddress.addressLine2 = addressLookup.addressLine3;
        postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm = "";
        this.searchresults = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      this.postCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.postCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  showConfirmAddressDelete(addressHistoryId: number) {
    this.showAddHistoryConfirmDelete = true;
    this.addressHistoryIdToDelete = addressHistoryId;
  }

  /** Promotes/converts a search to a case */
  promoteSearchToCase() {
    this.dealClient
      .promoteSearchToCase({ dealId: this.dealId, productFamily: ProductFamilyEnum.Commercial })
      .then((response: PromoteSearchToCaseResponse) => {
        if (response != null && response.commercialDeal != null) {
          this.dealDto = response.commercialDeal;
          this.shortlistedLendersName = response.shortlistedLendersName;
          this.selectedLendersName = response.selectedLendersName;
          this.shortListedLendersId = response.shortlistedLendersId;
          this.postRetrieveProcessing();
          this.getCurrentUserAndRoles();
        } else {
          this.message = "Problem while promoting a search to case, please try after some time.";
          this.showErrorMessage = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.getLenderPortalLinks();
      });
  }

  getLenderPortalLinks() {
    this.dealLenderClient
      .fetchByDealId(this.$routeParams.dealId)
      .then((dls: DealLender[]) => {
        this.dealLenders = dls;
        var searchChanged = this.$routeParams.SearchChanged;
        const lenderIds = dls
          .filter(
            (dl) =>
              !dl.hasAppliedInLenderPortal &&
              (dl.status === CaseLenderStateEnum.Shortlisted || searchChanged == "true"),
          )
          .map((dl) => dl.lenderId);
        return this.lenderClient.getLenderPortalLinks(lenderIds);
      })
      .then((links) => {
        this.portalLinks = links;
      })
      .catch((error) => {
        this.message = "Error fetching lender portal links: " + error;
        this.portalLinks = null;
      })
      .finally(() => {
        this.showLenderPortalLinks = Object.keys(this.portalLinks).length > 0;
      });
  }

  openPortalLink(dealLenderId: number, url: string) {
    if (!this.portalLinkDetailsAdded[dealLenderId]) {
      this.dealLenderClient
        .addLenderPortalLinkDetails(dealLenderId, this.borrowerDetails)
        .then(() => {
          this.portalLinkDetailsAdded[dealLenderId] = true;
          this.openUrl(url);
        })
        .catch((error) => {
          console.error("Error adding lender portal link details:", error);
        });
    } else {
      this.openUrl(url);
    }
  }

  private openUrl(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
  }

  saveOverview(): void {
    this.dealDto.projectDescription = this.caseOverview;

    this.commercialDealCrudClient
      .patch({ id: this.dealDto.id, projectDescription: this.dealDto.projectDescription })
      .then((response) => {
        this.dataLoading = false;
      });
  }

  gotoResultpage() {
    this.showErrorMessage = false;
    this.$location.path("/commercialresults/" + this.dealId);
  }

  onFileSelect(files) {
    var module = ModuleEnum.Case;

    this.dealFileAttachmentHelper
      .UploadFileListInSync(files, this.uploadingFiles, this.dealDto.id, this.fileUpload, module)
      .finally(() => {
        this.dataLoading = false;
      });
  }

  calculateTotalFilesRemoving(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module != filter).length;
    }
    return this.total;
  }

  downloadFile(file: DealFileAttachment, downloadFile: boolean = false) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        if (downloadFile) {
          this.sharedDealService.downloadFile(uri, file.fileName);
        } else {
          this.$window.open(uri);
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  renameFile(file: DealFileAttachment) {
    if (this.renamingFile === undefined) {
      // if renaming this file will dirty the case, we'll want to set it back to pristine when we're done.
      // this.renamingFileDirties = !$scope.caseForm.$dirty;
      this.renamingFile = file;
    } else {
      delete this.renamingFile;
    }
  }
  renamingFileComplete(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .fileRename(file)
      .then((response) => {
        file.tempURL = response.tempURL;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  renamingLinkCompleted(link: ExternalLinks) {
    this.dataLoading = true;
    this.externalLinksClient
      .addUpdate(link)
      .then((response) => {
        link.link = response.link;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  deleteFile(file: DealFileAttachment) {
    this.dealDto.attachments.splice(this.dealDto.attachments.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => {}); //remove on the server
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders button is clicked*/
  showTermsAndConditionsForBorrower() {
    this.showApplyTsAndCs = true;
    this.requestMessageReason = "a review";
    this.showTsAndCs = true;
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders HoT button is clicked (borrower/broker) */
  showTermsAndConditions() {
    this.dataLoading = true;
    this.lenderClient
      .getShortlistedLendersInfoForSubmitToLenders(
        LenderProductTypeEnum.CommercialMortgages,
        true,
        this.shortListedLendersId,
      )
      .then((response) => {
        this.lendersDetailsForSubmittoLenders = response;
      })
      .finally(() => {
        this.showTsAndCs = true;
        this.showTsAndCsForm = true;
        this.dealDto.submitTsAndCs = false;
        this.invalidEmail = false;
        this.dataLoading = false;
      });
  }

  gotoLendingPage() {
    (this.$rootScope as any).isLender = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  checkBrokerDeal() {
    return this.dealDto?.brokerUserId != null && this.isClient ? true : false;
  }

  /** Submits a case to lenders */
  submitCaseToLenders() {
    this.showTsAndCsForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;
    var isResubmitting = false;

    if (this.dealDto.status == CaseStatusEnum.ReadyToReSubmit) {
      isResubmitting = true;
    }

    var request = {
      dealId: this.dealId,
      productType: this.dealDto.productType,
      resubmitToLenders: isResubmitting,
      //BrokerCommission: Number(this.brokerCommission),
      lendersInfo: this.lendersDetailsForSubmittoLenders,
      brokerPhoneNumber: this.brokerPreferredContact,
      isBrokerPhoneNumberUpdated: this.isBrokerPhoneNumberUpdated,
      offPanelLenderNames: this.offPanelLenderNames,
    } as SubmitToLendersRequest;

    this.dealClient
      .submitToLenders(request)
      .then((response: CaseChangedMessageDTO) => {
        this.dealDto.status = response.caseState;
        this.caseService.updateCaseState(this.dealDto.id, response.caseState);
        this.showMessage("You have requested a Decision in Principle from each lender.");
        this.isSubmittedToLenders = true;
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong. Please try again.");
      })
      .finally(() => {
        this.sendingMessage = false;
        this.dataLoading = false;
      });
  }

  validateEmails() {
    this.invalidEmail = false;

    angular.forEach(this.lendersDetailsForSubmittoLenders, (lenderdetails, index) => {
      var emailField = this.lenderDetailsForm["email" + index];

      if (emailField && emailField.$invalid) {
        this.invalidEmail = true;
      }
    });
  }

  requestEmail(reason): void {
    this.showRequestEmailForm = true;
    this.requestMessageReason = reason;
    this.messagebool = true;
    this.messageContent = "";
  }

  getAppName() {
    let lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  closeConfirmationModal() {
    if (this.isSubmittedToLenders) {
      if (this.$routeParams.Promote) {
        this.$location.path("/commercialcasedashboard/" + this.dealDto.id);
      } else {
        window.location.reload();
      }
    }
    this.showTsAndCs = false;
  }

  viewResults() {
    if (this.dealDto.status == CaseStatusEnum.NewCase || (!this.isAdmin && !this.isBroker)) {
      this.$location.path("/commercialresults/" + this.dealDto.id);
    } else {
      this.$location.path("/commercialshortlistmore/" + this.dealDto.id);
    }
  }
  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked() {
    sessionStorage.setItem("lenderTask", "terms");
    this.$location.path("/commercialheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  /** Lender rejects the case*/
  rejectButtonClicked() {
    sessionStorage.setItem("lenderTask", "reject");
    this.$location.path("/commercialheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  withDrawButtonClicked() {
    sessionStorage.setItem("lenderTask", "withdraw");
    this.$location.path("/commercialheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  feedbackButtonClicked() {
    sessionStorage.setItem("lenderTask", "feedback");
    this.$location.path("/commercialheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  //Share module functions
  openShareModuleModal(contextToShare: AppraisalModuleEnum) {
    this.shareContext = contextToShare;
    this.constructShareNoteMessage();

    this.dealClientClient.fetchDealMembersWithAccess(this.dealDto.id).then((response: Client[]) => {
      this.caseMembersWithAccess = response;

      this.showShare = true;
    });
  }

  sendToBorrower(selectedClient) {
    this.dataLoading = true;

    const request: ShareModuleRequest = {
      clientFirstName: selectedClient.client.firstName,
      clientLastName: selectedClient.client.lastName,
      clientEmail: selectedClient.client.email,
      dealName: this.dealDto.name,
      dealId: this.dealDto.id,
      productFamily: ProductFamilyEnum.Commercial,
    };

    this.dealClient.shareDealToBorrower(request).then((success) => {
      if (success) {
        this.dataLoading = false;
        this.message =
          "The deal has been successfully shared with " +
          selectedClient.client.firstName +
          " " +
          selectedClient.client.lastName +
          ".";
      } else {
        this.message = "Sorry, something went wrong. Please try again.";
      }
      this.modal = true;
    });
  }

  isShareNoteFormComplete(): boolean {
    return this.selectedClientToShareWith && this.shareNote && this.shareNote.length > 0 ? true : false;
  }

  //End of Share module functions

  // Profile view functions

  /**
   * Show the Add/Edit permissions profile modal
   * @param applicant
   */
  showPermissionsProfileModal(profile: DealClient = null, isEdit: boolean = false): void {
    if (isEdit) {
      this.newApplicant = profile;
      this.isAddShareholder = false;
      this.showAddorEdit = true;
    } else {
      this.newApplicant = {} as DealClient;
      this.isAddShareholder = true;
      this.newApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
      this.showAddorEdit = true;
    }
  }

  resetApplicant() {
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.newApplicant = {} as DealClient;
    this.showAddorEdit = false;
  }

  /**
   * Saves the applicant being added/edited
   */
  saveApplicant(formController) {
    this.dataLoading = true;

    if (!(this.currentApplicant.id > 0)) {
      this.currentApplicant.isApplicant = true;
      this.currentApplicant.dealId = this.dealDto.id;
      this.currentApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
    }

    this.currentApplicant.uniqueRef = this.currentApplicant.uniqueRef ?? "";
    this.currentApplicant.accessLevel = this.currentApplicant.accessLevel ?? CaseAccessLevelEnum.Hidden;
    this.currentApplicant.ownershipPercentage = this.currentApplicant.ownershipPercentage ?? 0;
    this.currentApplicant.ownershipRole = this.currentApplicant.ownershipRole ?? OwnershipRoleEnum.None;
    this.currentApplicant.client =
      this.currentApplicant.client ??
      ({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        postalAddress: {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        },
      } as Client);
    this.currentApplicant.deal = this.currentApplicant.deal ?? null;

    this.saveUpdatedApplicant(this.currentApplicant, false, formController);
  }

  /**
   * Add or update a applicant
   * @param applicant
   */
  saveUpdatedApplicant(applicant: DealClient, isPermissionsProfile: boolean = false, formController = null): void {
    this.dataLoading = true;

    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again
    applicant.dealId = this.dealDto.id;

    //Below code is added for upgrade
    if (!(applicant.id > 0)) {
      applicant.deal = null;
      applicant.clientId = 0;
    }

    if (applicant.client) {
      applicant.client.phoneNumber ??= "";
      applicant.client.email ??= "";

      if (applicant.client.postalAddress != null) {
        applicant.client.postalAddress.addressLine1 ??= "";
        applicant.client.postalAddress.addressLine2 ??= "";
        applicant.client.postalAddress.addressLine3 ??= "";
        applicant.client.postalAddress.addressLine4 ??= "";
        applicant.client.postalAddress.postCode ??= "";
      }
    }
    // End of upgrade changes

    if (applicant) {
      this.dateProperties.forEach((property) => {
        let val = applicant[property];
        if (val) {
          applicant[property] = this.modifyDateForBackend(val);
        }
      });
    }

    if (applicant.profile) {
      this.profileDateProperties.forEach((property) => {
        let val = applicant.profile[property];
        if (val) {
          applicant.profile[property] = this.modifyDateForBackend(val);
        }
      });

      if (applicant.profile.postalAddress == null) {
        applicant.profile.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
      applicant.profile.profileUsers = applicant.profile.profileUsers ?? [];
      applicant.profile.qualifications = applicant.profile.qualifications ?? [];
      applicant.profile.assetLiabilityItems = applicant.profile.assetLiabilityItems ?? [];
    }

    if (applicant.client) {
      this.clientDateProperties.forEach((property) => {
        let val = applicant.client[property];
        if (val) {
          applicant.client[property] = this.modifyDateForBackend(val);
        }
      });

      if (
        (!applicant.client?.postalAddress && isPermissionsProfile) ||
        (!this.isAddShareholder && !applicant.client?.postalAddress && !applicant.id)
      ) {
        applicant.client.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
    }

    this.dealClientClient
      .addorUpdateApplicant(this.isAddShareholder, applicant)
      .then((response) => {
        this.dataLoading = true;

        if (response) {
          this.dateProperties.forEach((property) => {
            let val = response[property];
            if (val) {
              response[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.profile) {
          this.profileDateProperties.forEach((property) => {
            let val = response.profile[property];
            if (val) {
              response.profile[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.client) {
          this.clientDateProperties.forEach((property) => {
            let val = response.client[property];
            if (val) {
              response.client[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        const existingShareholder = this.applicantList.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.applicantList = this.applicantList.filter((member) => member.id != applicant.id);
          this.applicantList.push(response);
        } else {
          this.applicantList.push(response);
        }
        if (!isPermissionsProfile) {
          this.currentApplicant = response;
          formController.$setPristine();
        }
      })
      .finally(() => {
        delete this.newApplicant;
        this.showAddorEdit = false;
        this.disableQuickEditSave = false;
        this.dataLoading = false;
      });
  }

  cancelUpdateApplicant() {
    this.showAddorEdit = false;
    this.applicantList = this.applicantList.filter((applicant) => applicant.id != this.newApplicant?.id);
    this.applicantList.push(this.newApplicant); // Resets anything that is changed using the original data object
  }

  deleteApplicant(): void {
    this.dataLoading = true;
    this.dealClientClient
      .markAsDeleteAndSetNextApplicantAsPrimary(this.dealDto.id, this.confirmDeleteApplicant.id)
      .then((response) => {
        this.applicantList = response;
      })
      .finally(() => {
        this.dataLoading = false;
        this.confirmDeleteApplicant = {} as DealClient;
        this.showDelete = false;
      });
  }

  deleteConfirmApplicant(applicant: DealClient) {
    this.showDelete = true;
    this.confirmDeleteApplicant = applicant;
  }

  nonUkWarningVisible(): boolean {
    return this.sharedDealService.nonUkWarningVisible(this.currentApplicant);
  }

  showInviteButton(shareholder: DealClient) {
    return this.sharedDealService.showInviteButton(shareholder);
  }

  invite(applicant: DealClient) {
    this.dataLoading = true;

    this.dealClientClient
      .inviteApplicant(applicant.uniqueRef)
      .then((i) => {
        this.modal = true;
        this.message =
          "A request has been sent to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          " complete their shareholder profile.";
      })
      .catch((error) => {
        this.modal = true;
        this.message =
          "There was a problem sending the invite request to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          ". Please try again later.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  //End of Profile view functions

  /** Show and hide the export menu */
  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  modifyDateForBackend(property: Date) {
    return this.sharedDealService.modifyDateForBackend(property);
  }

  modifyDateForFrontend(property: Date) {
    return this.sharedDealService.modifyDateForFrontend(property);
  }

  goToUserDashboard() {
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = CommercialDealHelper.datasetupOnOwnOrPurchaseChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
    this.scheduleAutosave("netLoanRequired", this.dealDto.netLoanRequired, null);
    this.scheduleAutosave("maxLoanRequired", this.dealDto.maxLoanRequired, null);
  }

  onPropertyTabSelection() {
    if (this.dealDto) {
      this.showAppraisalPermission = false;
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Property;
      this.scrollTo("propertySection");
      this.onTabSelection();
    }
  }

  onLoanTabSelection() {
    if (this.dealDto) {
      this.showAppraisalPermission = false;
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Loan;
      this.scrollTo("loanSection");
      this.onTabSelection();
    }
  }

  onTabSelection() {
    this.tempDealDto = JSON.parse(JSON.stringify(this.dealDto));
  }

  trustedHtml(plainText) {
    if (this.isClient && plainText.startsWith("Project submitted to lenders")) {
      return this.$sce.trustAsHtml("Project submitted to lenders");
    } else {
      return this.$sce.trustAsHtml(plainText);
    }
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    this.datasetupOnOwnOrPurchaseChange();
    if (this.dealDto.ownOrPurchase != null && this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
      this.scheduleAutosave("originalPurchaseDate", this.dealDto.originalPurchaseDate, null);
      this.scheduleAutosave("currentvalue", this.dealDto.currentvalue, null);
    }

    if (this.dealDto.ownOrPurchase != null && this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
      this.scheduleAutosave("purchaseCosts", this.dealDto.purchaseCosts, null);
      this.scheduleAutosave("purchasePrice", this.dealDto.purchasePrice, null);
    }
    this.scheduleAutosave("ownOrPurchase", this.dealDto.ownOrPurchase, null);
  }

  onIsFamilyInResidenceChange() {
    this.dealDto.isFamilyInResidence = this.dealDto.hasIsFamilyInResidence ? YesNoMaybe.Yes : YesNoMaybe.No;
  }

  initialDataSetupForIsFamilyInResidence() {
    if (this.dealDto.hasIsFamilyInResidence) {
      this.dealDto.isFamilyInResidence = YesNoMaybe.Yes;
      this.dealDto.hasIsFamilyInResidence = true;
    } else {
      this.dealDto.isFamilyInResidence = YesNoMaybe.No;
      this.dealDto.hasIsFamilyInResidence = false;
    }
  }

  goToLoanTypeSelectionPage() {
    if (this.isLoggedInUser) {
      this.authService.setHasValidStatustoShowShareSearchModal(true);
    }
    this.$location.path("/allloans");
  }

  isValidDeal() {
    if (this.dealDto === null || this.dealDto === undefined) return true;
    if (this.dealForm && this.dealForm.$invalid) return true;

    if (
      this.dealDto.propertyAddress == null ||
      this.dealDto.propertyAddress.addressLine1 == null ||
      this.dealDto.propertyAddress.addressLine1.length <= 0 ||
      this.dealDto.propertyAddress.postCode == null ||
      this.dealDto.propertyAddress.postCode.length <= 0
    ) {
      return true;
    }

    if (this.dealDto.isFamilyInResidence == 0 || this.dealDto.isFamilyInResidence == YesNoMaybe.Yes) return true;

    const commonFields = [
      this.dealDto.ownOrPurchase,
      this.dealDto.locations,
      this.dealDto.loanRepaymentType,
      this.dealDto.currentPropertyType,
      this.dealDto.fixedRateTerm,
      this.dealDto.mortgageInterestType,
      this.dealDto.chargeRequired,
      this.dealDto.borrowingEntityType,
    ];

    for (let i = 0; i < commonFields.length; i++) {
      if (commonFields[i] == null || commonFields[i] == 0) {
        return true;
      }
    }

    if (this.dealDto.productType == ProductTypeEnum.CommercialInvestment) {
      if (this.dealDto.timeLeftOnLease == null || this.dealDto.timeLeftOnLease == 0) {
        return true;
      }
    }

    if (this.dealDto.productType == ProductTypeEnum.CommercialOwnerOccupied) {
      if (this.dealDto.tradingPeriod == null || this.dealDto.tradingPeriod == 0) {
        return true;
      }
    }

    return false;
  }

  initMortgageTerm() {
    this.dealDto.loanTermReq = this.dealDto.loanTermReq || 240;
    this.mortgageTerm = this.dealDto.loanTermReq / 12;
  }

  mortgageTermToLoanTerm() {
    this.dealDto.loanTermReq = this.mortgageTerm * 12;
    this.scheduleAutosave("loanTermReq", this.dealDto.loanTermReq, null);
  }

  onCurrentUseOfBuilding() {
    this.dealDto = CommercialDealHelper.datasetupOnCurrentUseOfBuilding(this.dealDto);
    this.scheduleAutosave("currentPropertyType", this.dealDto.currentPropertyType, this.dealForm.currentPropertyType);
  }

  onMortgageProductChange() {
    if (this.dealDto.mortgageInterestType == InterestRateTypeEnum.Variable) {
      this.dealDto.fixedRateTerm = null;
    } else if (this.dealDto.mortgageInterestType == InterestRateTypeEnum.Fixed) {
      this.dealDto.fixedRateTerm = FixedRateTermEnum.FiveYear;
    }
    this.scheduleAutosave("mortgageInterestType", this.dealDto.mortgageInterestType, null);
    this.scheduleAutosave("fixedRateTerm", this.dealDto.fixedRateTerm, null);
  }

  onPropertyTenureChange() {
    if (this.dealDto.propertyTenure == TenureEnum.Freehold) {
      this.dealDto.yearsLeftOnLease = 0;
    }
  }

  onOriginalGrossMonthlyRentalIncomeChange() {
    if (
      this.dealDto.grossMonthlyRentalIncome != null &&
      this.totalGrossMonthlyRentalIncome == this.dealDto.grossMonthlyRentalIncome
    ) {
      this.isGrossMonthlyRentalIncomeMatch = true;
    }
  }

  getOrganisationbyDealId() {
    this.organisationClient.getOrganisationAndBrokerByDealId(this.dealDto.id).then((response) => {
      this.org = response.organisation;
      this.dealBrokerUser = response.broker;
      //this.brokerCommission = this.dealDto.status == CaseStatusEnum.NewCase ? this.org?.CommissionPercent : this.dealDto.brokerCommissionPercent;
      this.brokerPreferredContact =
        this.dealDto.status == CaseStatusEnum.NewCase
          ? this.dealBrokerUser?.phoneNumber
          : this.dealDto.brokerPhoneNumber;

      if (this.org.isWhiteLabelled) {
        this.fileNamePrefix = this.org.name.replace(/ /g, "_");
      } else {
        this.fileNamePrefix = "Brickflow";
      }
    });
  }

  getOwnershipPercentageText() {
    if (this.dealDto != null) {
      return this.sharedDealService.getOwnershipPercentageText(this.currentApplicant, this.dealDto.productType);
    }
    return "Shareholding";
  }

  closeSubmitToLenderModal() {
    this.showTsAndCs = false;
    // this.brokerCommission = this.dealDto.status == CaseStatusEnum.NewCase ? this.org?.CommissionPercent : this.dealDto.brokerCommissionPercent;
    this.brokerPreferredContact =
      this.dealDto.status == CaseStatusEnum.NewCase ? this.dealBrokerUser?.phoneNumber : this.dealDto.brokerPhoneNumber;
    this.isBrokerPhoneNumberUpdated = false;
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions(true, this.isReadOnlyDeal);
  }

  logExportDownload(eventName) {
    this.eventLogClient.logEvent(eventName, EventLogEnum.Export, this.dealDto.productType, this.dealDto.id);
  }

  getTinymceOptions = function () {
    return this.isLender || this.isReadOnlyDeal ? this.tinymceReadonlyOptions : this.tinymceOverviewOptions;
  };

  confirmTabChangeWithSave() {
    this.saveOverview();
    if (this.pendingTabCallback) {
      this.pendingTabCallback.call(this);
    }
    this.resetUnsavedChangePrompt();
  }

  selectPropertyTab() {
    this.goToTab(2, this.onPropertyTabSelection);
  }

  selectLoanTab() {
    this.goToTab(3, this.onLoanTabSelection);
  }

  openCasePermissions() {
    this.goToTab("appraisalPermission", function () {
      this.showAppraisalPermission = true;
    });
  }

  openRequestAssistance() {
    this.goToTab("requistAssistance", function () {
      this.requestEmail("assistance");
    });
  }

  handleTermsAndConditions() {
    this.goToTab("termsAndConditions", function () {
      this.showTermsAndConditions();
    });
  }

  handleDealForum() {
    this.goToTab("dealForum", function () {
      this.gotoLendingPage();
    });
  }

  handeShareModuleModal(sectionId) {
    this.goToTab("shareModule:" + sectionId, function () {
      this.openShareModuleModal(sectionId);
    });
  }

  handleViewResults() {
    this.goToTab("viewResults", function () {
      this.viewResults();
    });
  }

  handleEditDealName() {
    this.goToTab("editDealName", function () {
      this.editDealName();
    });
  }

  initTinyEditors() {
    this.tinymceOverviewOptions = angular.copy(this.tinymceOptions);
    this.tinymceOverviewOptions.height = undefined;
    this.tinymceOverviewOptions.setup = (editor) => {
      editor.on("focus", () => {
        this.$scope.$evalAsync(() => {
          this.onOverviewFocus();
        });
      });
      editor.on("blur", () => {
        this.$scope.$evalAsync(() => {
          this.handleOverviewBlur();
        });
      });
    };
  }

  // Flush function (actually sends PATCH)
  flushAutosave() {
    //if (this.skipAutosave) return;

    if (Object.keys(this.pendingChanges).length > 1) {
      // more than just id
      const updatePayload: CommercialDealUpdate = { ...this.pendingChanges };

      this.commercialDealCrudClient.patch(updatePayload).then(() => {
        this.pendingChanges = { id: this.dealDto.id }; // reset after save
      });
    }
  }
}
